import styles from './Layout.module.scss'
import UserDropdown from "@/components/Layout/UserDropdown/UserDropdown";
import edhrecLogo from '@/assets/images/logo.png'
import Link from "next/link";
import {useRouter} from "next/router";
import { useEffect, useState } from 'react';
import classNames from "classnames";
import Icon from "@/components/UI/Icon/Icon";
import DarkModeToggle from './DarkModeToggle/DarkModeToggle';
import Button from "@/components/UI/Button/Button";

type Props = {
  children: React.ReactNode;
}

const FULL_WIDTH_PAGES = [
  '/crossword',
  '/crossword/test',
  '/commander-codex',
  '/spellify',
  '/spellify/hard',
  '/spellify/infinite',
  '/spellify/salt',
  '/quiz-builder'
]
const Layout = ({ children }: Props) => {

  const router = useRouter()

  const isFullWidth = FULL_WIDTH_PAGES.includes(router.pathname)
  const [hamburgerOpen, setHamburgerOpen] = useState<boolean>(false)

  const toggleHamburger = () => {
    setHamburgerOpen(!hamburgerOpen)
  }

  useEffect(() => {
    setHamburgerOpen(false)
  }, [router.pathname])

  return (
    <div className={styles.wrapper}>



      <nav className={classNames(styles.simpleNav, styles.edhrecNav)}>
        <Link href="https://edhrec.com" style={{height: 40}}>
          <img height="40" src={edhrecLogo.src} alt="EDHREC" className={styles.edhrecLogo}/>
        </Link>
        <div className={styles.rightButtons}>
          <UserDropdown/>
          <div className={styles.hamburger} onClick={toggleHamburger}>
            <Icon icon="bars"/>
          </div>
        </div>

      </nav>


      <nav className={classNames(styles.nav, !hamburgerOpen && styles.hiddenMobile, styles.edhrecNav)}>
        <div className={styles.leftNav}>

          <Link href="https://edhrec.com" style={{height: 40}}>
            <img height="40" src={edhrecLogo.src} alt="EDHREC" className={styles.edhrecLogo} />
          </Link>
          {/*<Link href="/commander-codex">*/}
          {/*  Commander Codex*/}
          {/*</Link> */}
          <Link href="/quiz">
            Quizzes
          </Link>
          <Link href="/spellify">
            Spellify
          </Link>
          <Link href="/spellify/hard">
            Spellify Hard Mode
          </Link>
          <Link href="/crossword">
            Crossword
          </Link>
          <DarkModeToggle />
        </div>
        <div className={styles.rightButtons}>
          <div className={styles.hiddenMobile}>
            <UserDropdown/>
          </div>

          <a href="https://edhrec.com"><Button color="blue" simple>Return to EDHREC</Button></a>
        </div>




      </nav>

      <main className={classNames(styles.main, isFullWidth && styles.fullWidth)}>
        {children}
      </main>
    </div>
  )
}

export default Layout